import * as Yup from "yup";
import {
  invalidValue,
  requiredDigitInputFieldRegex,
  requiredLetterInputFieldRegex,
  requiredLetterInputFieldRegexMessage,
  requireCheckboxMessage,
  streetAddressDigitOrLetterInputFieldRegex,
  unitNumberDigitOrLetterInputFieldRegex,
  startWithNumberRegex,
  startWithNumberMessage,
  numberBetweenTenAndTenThousand,
  requiredStreetInputFieldRegex,
  requiredStreetInputFieldRegexMessage,
  postCodeLengthMessage,
  streetNumberRequiredMessage,
  postCodeRequiredMessage,
  suburbRequiredMessage,
  streetNameRequiredMessage,
  stateRequiredMessage,
  maritalStatusRequiredMessage,
  dependentsRequiredMessage,
  residentialStatusRequiredMessage,
  residentialPaymentRequiredMessage,
  foreseeableChangesRequiredMessage,
  foreseeableChangesDetailsRequiredMessage,
} from "./shared";
import { shouldShowResidentialPayment } from "../components/residential/ResidentialPayment";

export const livingSituationSchema = Yup.object({
  acceptsPrivacyPolicy: Yup.bool().oneOf([true], requireCheckboxMessage),
  unitNumber: Yup.string()
    .matches(startWithNumberRegex, {
      message: startWithNumberMessage,
      excludeEmptyString: true
    })
    .matches(unitNumberDigitOrLetterInputFieldRegex, {
      message: invalidValue,
      excludeEmptyString: true,
    }),
  streetNumber: Yup.string()
    .required(streetNumberRequiredMessage)
    .matches(startWithNumberRegex, {
      message: startWithNumberMessage,
      excludeEmptyString: true
    })
    .matches(streetAddressDigitOrLetterInputFieldRegex, {
      message: invalidValue,
      excludeEmptyString: true,
    }),
  suburb: Yup.string()
    .trim()
    .required(suburbRequiredMessage)
    .matches(requiredLetterInputFieldRegex, {
      message: invalidValue,
      excludeEmptyString: true,
    }),
  street: Yup.string().trim()
    .matches(requiredStreetInputFieldRegex, {
      message: requiredStreetInputFieldRegexMessage,
      excludeEmptyString: true,
    })
    .min(2, requiredLetterInputFieldRegexMessage)
    .required(streetNameRequiredMessage),
  state: Yup.string().trim().required(stateRequiredMessage),
  postCode: Yup.string()
    .required(postCodeRequiredMessage)
    .matches(requiredDigitInputFieldRegex, {
      message: invalidValue,
      excludeEmptyString: true,
    })
    .length(4, postCodeLengthMessage),
  maritalStatus: Yup.string().trim().required(maritalStatusRequiredMessage),
  numberOfDependents: Yup.string().trim().required(dependentsRequiredMessage),
  residentialStatus: Yup.string().trim().required(residentialStatusRequiredMessage),
  residentialPayment: Yup.string().when("residentialStatus", {
    is: (residentialStatus) =>
      shouldShowResidentialPayment({ residentialStatus }),
    then: () => Yup.string()
      .trim()
      .test("test-MinMax", numberBetweenTenAndTenThousand, (value) => {
        return value >= 10 && value <= 10000;
      })
      .required(residentialPaymentRequiredMessage),
  }),
  foreseeableChanges: Yup.string()
    .trim()
    .required(foreseeableChangesRequiredMessage),

  foreseeableChangesExplain: Yup.string()
    .when("foreseeableChanges", {
      is: "true",
      then: () => Yup.string()
        .trim()
        .required(foreseeableChangesDetailsRequiredMessage)
        .max(650)
    }),
});
